import NavigationTabs from "@/components/NavigationTabs";
import FlexColumn from "@/components/FlexColumn";
import { mapMutations, mapState, mapGetters, mapActions } from "vuex";
import StrategicPeriodTable from "@/components/ppc_v2/StrategicPeriodTable";
import PerformancePeriodTable from "@/components/ppc_v2/PerformancePeriodTable";
import PerformanceCards from "@/components/kpi-cards/ppc_v2/PerformanceCards";
import AppDropdown from "@/components/AppDropdown";
import AppButtonRadioGroup from "@/components/AppButtonRadioGroup";
import { EVENTS, PPC_EXTRA_FILTERS } from "@/utils/constants";
import { DATE_PICKER_COMPARE_TITLES, getDatePickerRangeCompare, getDatePickerUIObjectFromDateRange } from "@/utils/datepicker";
import PPCManagementMixin from "@/mixins/PPCManagementMixin.vue";
import PpcV2Filters from "@/components/PpcV2Filters.vue";
import moment from "moment";
import PpcV2MoreFilters from "@/components/PpcV2MoreFilters.vue";
import ProductTable from "@/components/ppc_v2/ProductTable.vue";
import LiteTableMixin from "@/mixins/LiteTableMixin.vue";
import PpcSettings from "@/components/ppc/PpcSettings.vue";
import PpcSettingsFilters from "@/components/ppc/PpcSettingsFilters.vue";
import CurrencyFilter from "@/components/new-filters/CurrencyFilter.vue";
import PPCSettingsTabs from "@/components/PPCSettingsTabs.vue";
import PauseInCircleIcon from "@/components/icons/PauseInCircleIcon.vue";
import PpcAutomationController from "@/components/PpcAutomationController.vue";
import WrapWithOverlay from "@/components/WrapWithOverlay.vue";
import PeriodControllers from "@/components/PeriodControllers.vue";
import { FilterManager } from "@/store/filter";
import { FILTER_KEYS } from "../utils/constants";
import TabbedKpiCards from "@/components/kpi-cards/dashboard_v2/v2/TabbedKpiCards.vue";
import DashboardV2Mixin from "@/mixins/DashboardV2Mixin.vue";
import { FLOATING_COMPOUND_TABLE_STATES } from "../utils/constants";
export default {
  name: "PPCManagementPage",
  components: {
    NavigationTabs,
    FlexColumn,
    StrategicPeriodTable,
    PerformancePeriodTable,
    PerformanceCards,
    AppDropdown,
    AppButtonRadioGroup,
    PpcV2Filters,
    PpcV2MoreFilters,
    ProductTable,
    PpcSettingsFilters,
    PpcSettings,
    CurrencyFilter,
    PPCSettingsTabs,
    PauseInCircleIcon,
    PpcAutomationController,
    WrapWithOverlay,
    PeriodControllers,
    TabbedKpiCards
  },
  mixins: [PPCManagementMixin, LiteTableMixin, DashboardV2Mixin],
  beforeUnmount() {
    window.$bus.off(EVENTS.REFRESH_PPC_MANAGEMENT, () => this.refreshAllKpis());
    window.$bus.off(EVENTS.SET_MORE_FILTERS, this.handleMoreFilters);
  },
  async mounted() {
    this.datePickerCommitterFunction = this.ppcV2SetProductTablePeriod;
    this.$store.dispatch("ppcV2SetDefaultCurrency");
    window.$bus.on(EVENTS.REFRESH_PPC_MANAGEMENT, async () => await this.refreshAllKpis());
    window.$bus.on(EVENTS.PPC_SETTINGS_INITIALIZED, value => {
      this.ppcSettingsInitialized = value;
    });
    window.$bus.on(EVENTS.SET_MORE_FILTERS, this.handleMoreFilters);
    await this.initializeSellersFilter(this.ppcSellersFilterSet);
    await this.initializeMarketplacesFilter(this.ppcMarketplacesFilterSet, true);
    await this.initializeBrandsFilter({
      sellers: this.currentSellerIds
    }, this.brands_filter, "dashboard/v2");
    this.marketplaces_filter._key = "sales_channel";
    const filterManager = new FilterManager({
      sellersFilter: this.sellers_filter,
      marketplacesFilter: this.marketplaces_filter,
      rootPath: "ppc/v2"
    });
    const secondaryFilters = {
      [FILTER_KEYS.CAMPAIGNS]: {
        storeFilter: this.campaigns,
        initializer: this.initializeCampaignsFilters
      },
      [FILTER_KEYS.MATCH_TYPES]: {
        storeFilter: this.match_types,
        initializer: this.initializeMatchTypesFilters
      },
      [FILTER_KEYS.TARGETINGS]: {
        storeFilter: this.targetings,
        initializer: this.initializeTargetingsFilters
      },
      [FILTER_KEYS.AD_FORMATS]: {
        storeFilter: this.ad_formats,
        initializer: this.initializeAdFormatsFilters
      },
      [FILTER_KEYS.PORTFOLIOS]: {
        storeFilter: this.portfolios,
        initializer: this.initializePortfoliosFilters
      },
      [FILTER_KEYS.CAMPAIGN_GROUPS]: {
        storeFilter: this.campaign_groups,
        initializer: this.initializeCampaignGroupsFilters
      }
    };
    filterManager.registerAll(secondaryFilters);
    this.$store.dispatch("ppcV2SetFilterManager", filterManager);
    this.refreshPpcAutomationStatus();
    window.$bus.on(EVENTS.REFRESH_PPC_AUTOMATION_STATUS, async () => await this.refreshPpcAutomationStatus());
    this.$store.dispatch("ppcV2SetProductTableGroupByElements");
    this.applyPeriodForDatePicker(this.periodGroupBy, this.periodCategory);
    this.refreshAllKpis();
    this.filterManager.refreshSet(this.filterKeysToRefresh);
    window.$bus.on(EVENTS.REFRESH_PPC_V2_SELLERS_SUB_FILTERS, this.refreshPPCSellersSubFilters);
    window.$bus.on(EVENTS.REFRESH_PPC_V2_MARKETPLACES_SUB_FILTERS, this.refreshPPCMarketPlacesSubFilters);
  },
  data(ctx) {
    return {
      today: moment(),
      sellers: [],
      marketplaces: [],
      periodTableLoading: true,
      productTableLoading: true,
      kpisLoading: true,
      moreFilters: false,
      activateSettings: true,
      openModal: false,
      hideSettingsFooterButtons: true,
      ppcAutomationStatus: "UNKNOWN",
      rightStripFeatureName: "ppcsettingsfeature",
      mediatorRefreshers: {
        KPIS: this.refreshKpis,
        PERIOD_TABLE: this.refreshPeriodTable,
        PRODUCT_TABLE: this.refreshProductTable
      },
      secondaryFilterInitializers: {
        [PPC_EXTRA_FILTERS.CAMPAIGN]: () => ctx.initializeCampaignsFilters({
          sellers: ctx.sellers_filter.filterValues,
          sales_channel: ctx.marketplaces_filter.filterValues,
          ...ctx.ppcV2FilterRelationParams()
        }, ctx.campaigns, "ppc/v2"),
        [PPC_EXTRA_FILTERS.MATCH_TYPE]: () => ctx.initializeMatchTypesFilters({
          sellers: ctx.sellers_filter.filterValues,
          sales_channel: ctx.marketplaces_filter.filterValues
        }, ctx.match_types, "ppc/v2"),
        [PPC_EXTRA_FILTERS.TARGETING]: () => ctx.initializeTargetingsFilters({
          sellers: ctx.sellers_filter.filterValues,
          sales_channel: ctx.marketplaces_filter.filterValues
        }, ctx.targetings, "ppc/v2"),
        [PPC_EXTRA_FILTERS.AD_FORMAT]: () => ctx.initializeAdFormatsFilters({
          sellers: ctx.sellers_filter.filterValues,
          sales_channel: ctx.marketplaces_filter.filterValues
        }, ctx.ad_formats, "ppc/v2"),
        [PPC_EXTRA_FILTERS.PORTFOLIO]: () => ctx.initializePortfoliosFilters({
          sellers: ctx.sellers_filter.filterValues,
          sales_channel: ctx.marketplaces_filter.filterValues
        }, ctx.portfolios, "ppc/v2"),
        [PPC_EXTRA_FILTERS.CAMPAIGN_GROUP]: () => ctx.initializeCampaignGroupsFilters({
          sellers: ctx.sellers_filter.filterValues,
          sales_channel: ctx.marketplaces_filter.filterValues,
          ...ctx.ppcV2FilterRelationParams()
        }, ctx.campaign_groups, "ppc/v2")
      },
      settingsTabs: [{
        title: "Global Bidding Rules",
        subtitle: "Define default bidding rules for SP and SB campaigns",
        value: "bidding",
        activeBg: "#F4F8FF",
        activeColor: "#2172E1",
        activeBorderColor: "#8AB4FF",
        icon: "CoinsHandIcon",
        disabled: false
      }, {
        title: "Sponsored Product settings",
        subtitle: "Manage budget pacing and adjust bids at product level",
        value: "sp_budget",
        activeBg: "#F4F8FF",
        activeColor: "#2172E1",
        activeBorderColor: "#8AB4FF",
        icon: "BoxIcon",
        disabled: false
      }, {
        title: "Sponsored Brand settings",
        subtitle: "Manage budgets and adjust bids at the SB campaign level",
        value: "sb_budget",
        activeBg: "#F4F8FF",
        activeColor: "#2172E1",
        activeBorderColor: "#8AB4FF",
        icon: "CartIcon",
        disabled: false
      }],
      currentSettingsTab: 0,
      ppcAutomationLoading: false,
      ppcAutomationErrorOccured: false,
      ppcSettingsInitialized: false,
      FLOATING_COMPOUND_TABLE_STATES
    };
  },
  watch: {
    currentTabValue: {
      async handler(newTab, oldTab) {
        if (oldTab === "settings" && ["performance", "strategic"].includes(newTab)) {
          await this.initializeSellersFilter(this.ppcSellersFilterSet);
          await this.initializeMarketplacesFilter(this.ppcMarketplacesFilterSet, true);
          this.marketplaces_filter._key = "sales_channel";
          this.refreshAllKpis();
        }
      },
      immediate: true
    }
  },
  computed: {
    ...mapState({
      currentTab: state => state.ppc_v2.currentTab,
      currentTabValue: state => state.ppc_v2.currentTabValue,
      tabs: state => state.ppc_v2.tabs,
      isOmnyAdmin: state => state.auth.isOmnyAdmin,
      isOmnyUser: state => state.auth.isOmnyUser,
      currentPeriod: state => state.ppc_v2.currentPeriod,
      periodSelectorOptions: state => state.ppc_v2.periodSelectorOptions,
      floatingTableState: state => state.ppc_v2.product_table.state,
      productTableGroupBy: state => state.ppc_v2.product_table.group_by_text,
      productTable: state => state.ppc_v2.product_table,
      currencies: state => state.ppc_v2.currencies,
      sellers_filter: state => state.ppc_v2.sellers_filter,
      marketplaces_filter: state => state.ppc_v2.marketplaces_filter,
      products: state => state.ppc_v2.products,
      match_types: state => state.ppc_v2.match_types,
      campaigns: state => state.ppc_v2.campaigns,
      targetings: state => state.ppc_v2.targetings,
      portfolios: state => state.ppc_v2.portfolios,
      ad_formats: state => state.ppc_v2.ad_formats,
      campaign_groups: state => state.ppc_v2.campaign_groups,
      kpis_v2: state => state.ppc_v2.kpis_v2.considered_kpis,
      periodSetting: state => state.ppc_v2.period,
      brands_filter: state => state.ppc_v2.brands,
      filterManager: state => state.ppc_v2.filterManager
    }),
    ...mapGetters(["ppcV2GetPeriod", "getSystemWeekType", "ppcV2SecondaryFiltersEnabled", "ppcV2UserOnSettingsPage", "ppcV2GetPeriodCategory", "ppcV2GetTabs", "accountGetPPCAutomationStatus", "ppcSettingsSelectedSellerAndMarketplace", "accountAdvertisingGetBySellerMarketplace", "ppcV2GetFilters", "currencyConfigQueryGet", "dateConfigQueryGet", "ppcV2GetPeriodOptions", "ppcV2RenderedFilterKeys", "ppcV2FilterRelationParams"]),
    computedCurrentSettingsTab: {
      get() {
        return this.currentSettingsTab;
      },
      async set(value) {
        await this.goToTab(value);
      }
    },
    periodOptions() {
      return this.ppcV2GetPeriodOptions;
    },
    currentSellerIds() {
      return this.sellers_filter.filterItems.map(seller => seller.id);
    },
    canChangeAutomationStatus() {
      const possible_automation_status = ["ENABLED", "PAUSED"];
      return possible_automation_status.includes(this.ppcAutomationStatus);
    },
    currentMarketplaceIds() {
      return this.marketplaces_filter.filterItems.filter(({
        sales_channel
      }) => sales_channel !== "-").map(marketplace => marketplace.sales_channel);
    },
    ppcSettingsFilters() {
      let sellers_filter_item = this.sellers_filter.filterItems.slice(-1).pop();
      this.selected_seller = sellers_filter_item;
      let marketplaces_filter_item = this.marketplaces_filter.filterItems.slice(-1).pop();
      return {
        seller_id: sellers_filter_item?.account_id,
        sales_channel: marketplaces_filter_item?.sales_channel,
        country_code: marketplaces_filter_item?.country_code,
        marketplace_id: marketplaces_filter_item?.marketplace_id
      };
    },
    period: {
      set(value) {
        this.$store.dispatch("ppcV2SetPeriod", value);
        this.applyPeriodForDatePicker(this.periodGroupBy, this.periodCategory);
        this.refreshMediator(["PERIOD_TABLE", "PRODUCT_TABLE"]);
      },
      get() {
        return this.ppcV2GetPeriod();
      }
    },
    tab: {
      async set(value) {
        this.$store.dispatch("ppcV2SetTab", value);
      },
      get() {
        return this.currentTab;
      }
    },
    periodGroupBy() {
      return this.getPeriodGroupFromCurrentPeriod(this.currentPeriod, this.period);
    },
    periodCategory: {
      set(value) {
        this.applyPeriodCategoryForDatePicker(this.datePickerDate, value);
        this.$store.dispatch("ppcV2SetPeriodCategory", value);
      },
      get() {
        return this.ppcV2GetPeriodCategory();
      }
    },
    pausedPpcAutomationStatus() {
      const possible_automation_status = ["UNKNOWN", "PAUSED"];
      return possible_automation_status.includes(this.ppcAutomationStatus);
    },
    filterKeysToRefresh() {
      return this.ppcV2RenderedFilterKeys();
    },
    datePickerDate() {
      return this.productTable[this.currentTabValue]?.period;
    }
  },
  methods: {
    ...mapMutations(["ppcSellersFilterSet", "ppcMarketplacesFilterSet"]),
    ...mapActions(["accountPausePPCAutomation", "accountEnablePPCAutomation"]),
    getAdvertisingTabs() {
      return this.tabs;
    },
    getSettingsTabs() {
      return this.settingsTabs;
    },
    async goToTab(tabValue) {
      this.currentSettingsTab = tabValue;
      await this.$nextTick();
    },
    storeDatePickerDate(date) {
      this.$store.dispatch("ppcV2SetProductTablePeriod", date);
      window.$bus.trigger(EVENTS.RESET_DATE_PICKER, date);
    },
    async refreshKpis() {
      this.kpisLoading = true;
      await this.$store.dispatch("ppcV2FetchKpis");
      this.kpisLoading = false;
    },
    async refreshPeriodTable() {
      this.$store.dispatch("ppcV2SetPeriodTableErrorState", false);
      this.periodTableLoading = true;
      await this.$store.dispatch("ppcV2FetchPeriodTableData");
      this.periodTableLoading = false;
    },
    async refreshProductTable() {
      if (this.currentTabValue !== "settings") {
        this.productTableLoading = true;
        this.$store.dispatch("ppcV2SetProductTableErrorState", false);
        let previousPeriodCategory = this.periodCategory;
        this.periodCategory = "prev_period";
        const groupByFetch = this.productTable[this.currentTabValue].data[this.productTableGroupBy]?.fetch;
        if (groupByFetch) await this.$store.dispatch(groupByFetch);
        this.periodCategory = previousPeriodCategory;
        this.productTableLoading = false;
      }
    },
    async refreshMediator(refresheeList) {
      const perf = [];
      perf.push(performance.now());
      refresheeList.forEach(refreshee => {
        this.mediatorRefreshers[refreshee]();
      });
      perf.push(performance.now());
    },
    handleMoreFilters(value) {
      this.moreFilters = value;
    },
    handleErrorOccured() {
      this.announceNoAccounts();
      this.periodTableLoading = false;
      this.productTableLoading = false;
      this.kpisLoading = false;
    },
    async handleDateChange(date) {
      if (!date) {
        date = this.applyPeriodForDatePicker(this.periodGroupBy, this.periodCategory);
      }
      this.storeDatePickerDate(date);
      await this.refreshMediator(["PRODUCT_TABLE"]);
    },
    // Clear any evolution row selection without refetching.
    restoreEvolutionTable() {
      this.$store.commit("ppcV2DeselectPeriodTable");
    },
    handleSetPeriodTablePeriod(date) {
      this.handleSetLiteTablePeriod(date, this.period, this.handleDateChange, this.datePickerCompareTitle(this.periodCategory));
    },
    async handleProductTableSort({
      sort,
      direction
    }) {
      this.$store.dispatch("ppcV2SetProductTableSort", {
        sort,
        direction
      });
      await this.refreshMediator(["PRODUCT_TABLE"]);
    },
    handleProductTableRefresh() {
      this.refreshAllKpis();
    },
    getFeatureName() {
      return "ppcsettingsfeature";
    },
    async refreshAllKpis() {
      this.refreshMediator(["KPIS", "PRODUCT_TABLE", "PERIOD_TABLE"]);
      this.kpisLoading = true;
      await this.$store.dispatch("ppcV2FetchKpis");
      this.kpisLoading = false;
    },
    handleApplyForCurrencyChange() {
      if (this.currencies.isModified) {
        this.currencies.apply();
        this.$store.dispatch("currencyConfigSetCurrency", this.currencies.filterValues[0]);
        this.refreshAllKpis();
      }
    },
    async enablePPCAutomation() {
      try {
        this.ppcAutomationLoading = true;
        this.ppcAutomationErrorOccured = false;
        const selected_filter_item = this.ppcSettingsFilters;
        const account = this.accountAdvertisingGetBySellerMarketplace({
          seller_id: selected_filter_item.seller_id,
          marketplace_id: selected_filter_item.marketplace_id
        });
        //if (!account) {
        //  console.error("Failed to get account from ", params)
        //}
        // Remove the `_id` field from account
        delete account["_id"];
        const result = await this.accountEnablePPCAutomation(account);
        this.throwIfError(result.status);
        window.$bus.trigger(EVENTS.REFRESH_PPC_AUTOMATION_STATUS);
        await window.$bus.trigger(EVENTS.REFRESH_PPC_SETTINGS);
      } catch (error) {
        window.$bus.trigger("showDanger", {
          message: `Error enabling PPC automation: ${error?.message}`,
          delay: 50,
          visible: true
        });
        this.ppcAutomationErrorOccured = true;
      } finally {
        this.ppcAutomationLoading = false;
      }
    },
    async pausePPCAutomation() {
      try {
        this.ppcAutomationLoading = true;
        this.ppcAutomationErrorOccured = false;
        const selected_filter_item = this.ppcSettingsFilters;
        const account = this.accountAdvertisingGetBySellerMarketplace({
          seller_id: selected_filter_item.seller_id,
          marketplace_id: selected_filter_item.marketplace_id
        });
        //if (!account) {
        //  console.error("Failed to get account from ", params)
        //}
        // Remove the `_id` field from account
        delete account["_id"];
        const result = await this.accountPausePPCAutomation(account);
        this.throwIfError(result.status);
        window.$bus.trigger(EVENTS.REFRESH_PPC_AUTOMATION_STATUS);
        await window.$bus.trigger(EVENTS.REFRESH_PPC_SETTINGS);
      } catch (error) {
        window.$bus.trigger("showDanger", {
          message: `Error pausing PPC automation: ${error?.message}`,
          delay: 50,
          visible: true
        });
        this.ppcAutomationErrorOccured = true;
      } finally {
        this.ppcAutomationLoading = false;
      }
    },
    refreshPpcAutomationStatus() {
      const selected_filter_item = this.ppcSettingsFilters;
      this.ppcAutomationStatus = this.accountGetPPCAutomationStatus({
        seller_id: selected_filter_item.seller_id,
        marketplace_id: selected_filter_item.marketplace_id
      });
    },
    async refreshPPCSellersSubFilters(check_local_storage) {
      await this.initializeMarketplacesFilter(this.ppcMarketplacesFilterSet, check_local_storage);
      this.marketplaces_filter._key = "sales_channel";
      await this.filterManager.refreshSet(this.filterKeysToRefresh);
    },
    async refreshPPCMarketPlacesSubFilters() {
      await this.filterManager.refreshSet(this.filterKeysToRefresh);
    }
  }
};